import { getPartnerConfig } from '../partnerConfig';
import { AssetUrls } from 'config/assets';

const TRADEMAGIC_LOGO_URL =
  'https://trademagic-assets.s3.us-west-1.amazonaws.com/assets/integrations/banner_social_share_apple.png';

interface PartnerHeaderProps {
  partner?: string;
}

const PartnerHeader = ({ partner }: PartnerHeaderProps) => {
  const config = getPartnerConfig(partner);

  return (
    <div className="partner-header">
      <div className="partner-header-content">
        <div className="partner-logos-row">
          {config.logo ? (
            <img
              src={config.logo}
              alt={`${config.name} logo`}
              className="partner-logo"
              onError={(e) => {
                (e.target as HTMLImageElement).src = AssetUrls.logos.iconLogo;
              }}
            />
          ) : (
            <img
              src={AssetUrls.logos.iconLogo}
              alt="TradeMagic logo"
              className="partner-logo"
            />
          )}
          <span className="partner-arrow">→</span>
          <img
            src={TRADEMAGIC_LOGO_URL}
            alt="TradeMagic logo"
            className="trademagic-destination-logo"
          />
        </div>
        <h1 className="partner-title">
          {config.name !== 'Import Collection' ? `Import from ${config.name}` : config.name}
        </h1>
      </div>
    </div>
  );
};

export default PartnerHeader;
